import React from 'react';
import SEO from '@/components/SEO';
import HeroSection from '@/components/sections/about/HeroSection';
import FounderSection from '@/components/sections/about/FounderSection';
import ClientsSection from '@/components/sections/about/ClientsSection';
import FAQ from '@/components/ui/FAQ';

const About = () => {
  const faqItems = [
    {
      question: "Quelle est votre approche du développement ?",
      answer: "Nous privilégions une approche agile et itérative, en mettant l'accent sur la communication transparente et la livraison continue. Notre objectif est de créer des solutions évolutives qui répondent parfaitement aux besoins de nos clients tout en restant dans leur budget."
    },
    {
      question: "Comment assurez-vous la qualité de vos développements ?",
      answer: "Nous appliquons les meilleures pratiques de développement : tests automatisés, revue de code systématique, intégration continue, et monitoring des performances. Notre équipe suit également une veille technologique constante pour garantir l'utilisation des technologies les plus adaptées."
    },
    {
      question: "Travaillez-vous avec des startups early-stage ?",
      answer: "Absolument ! Nous sommes spécialisés dans l'accompagnement des startups early-stage. Nous adaptons nos services et nos tarifs pour répondre aux besoins spécifiques des jeunes entreprises, tout en maintenant un niveau de qualité élevé."
    },
    {
      question: "Comment gérez-vous la communication avec vos clients ?",
      answer: "Nous maintenons une communication régulière via des points hebdomadaires, des démos fréquentes, et un accès permanent à notre outil de suivi de projet. Notre objectif est d'être transparents et réactifs pour garantir une collaboration efficace."
    },
    {
      question: "Proposez-vous un accompagnement post-développement ?",
      answer: "Oui, nous offrons un support continu après le lancement : maintenance, optimisations, évolutions fonctionnelles, et monitoring des performances. Nous considérons nos clients comme des partenaires à long terme."
    }
  ];

  return (
    <>
      <SEO 
        title="À Propos d'Orcsys - Votre Partenaire Tech"
        description="Découvrez qui nous sommes chez Orcsys : une équipe passionnée dédiée à la réussite de votre projet digital. Expertise technique, innovation et accompagnement personnalisé."
        keywords="orcsys, agence web, développement, startup, innovation, tech, équipe, expertise digitale, transformation numérique, partenaire technologique"
        type="company"
        url="https://innov.orcsys.fr/a-propos"
        image="https://innov.orcsys.fr/images/team.jpg"
        section="Company"
      />
      <div className="min-h-screen bg-white">
        <HeroSection />
        <FounderSection />
        <ClientsSection />
        <FAQ 
          title="Questions Fréquentes sur Notre Approche"
          subtitle="Découvrez comment nous travaillons et ce qui nous distingue"
          items={faqItems}
          className="bg-slate-50"
        />
      </div>
    </>
  );
};

export default About; 